var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalShippingCat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.131,
    height: 22,
    viewBox: "0 0 31.131 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "local_shipping_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M60.421-758a3.95,3.95,0,0,1-2.9-1.2,3.96,3.96,0,0,1-1.194-2.906H53.85v-15.257a2.549,2.549,0,0,1,.767-1.874A2.549,2.549,0,0,1,56.491-780H76.384v5.563h3.877l4.72,6.322v6.013H82.34a3.954,3.954,0,0,1-1.2,2.906,3.96,3.96,0,0,1-2.908,1.2,3.95,3.95,0,0,1-2.9-1.2,3.96,3.96,0,0,1-1.194-2.906H64.527a3.952,3.952,0,0,1-1.2,2.908A3.964,3.964,0,0,1,60.421-758Zm0-2.192a1.844,1.844,0,0,0,1.357-.554,1.845,1.845,0,0,0,.553-1.357,1.846,1.846,0,0,0-.553-1.357,1.845,1.845,0,0,0-1.357-.553,1.846,1.846,0,0,0-1.357.553,1.846,1.846,0,0,0-.553,1.357,1.845,1.845,0,0,0,.553,1.357A1.846,1.846,0,0,0,60.425-760.192Zm17.813,0a1.844,1.844,0,0,0,1.357-.554,1.844,1.844,0,0,0,.554-1.357,1.846,1.846,0,0,0-.554-1.357,1.845,1.845,0,0,0-1.357-.553,1.846,1.846,0,0,0-1.357.553,1.846,1.846,0,0,0-.553,1.357,1.845,1.845,0,0,0,.553,1.357A1.845,1.845,0,0,0,78.238-760.192Zm-1.854-7.024H82.93l-3.793-5.029H76.384Z",
    transform: "translate(-53.85 780)",
    fill: "#86899b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalShippingCat4);
export default __webpack_public_path__ + "static/media/local_shipping_cat_4.d9c91451f9a71d20cd85ba348d28eb48.svg";
export { ForwardRef as ReactComponent };